import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect, BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import Login from 'modules/billingPortal/authentication/login/Login';
import Dashboard from 'modules/billingPortal/dashboard/Dashboard';

import Distributor_Login from 'modules/distributorPortal/authentication/login/Login';
import Distributor_Dashboard from 'modules/distributorPortal/dashboard/Dashboard';

import { billingPortalBaseUrl } from "dataflow/billingPortal/constants";
import { distributorPortalBaseUrl } from "dataflow/distributorPortal/constants";

import 'assets/scss/app.scss';



export default function App() {
	// to avoid auto fill suggestions to appear at any input.
	useEffect(() => {
		let input = document.createElement("input");
		input.style.position = "absolute";
		input.style.top = "0";
		input.style.pointerEvent = "none";
		input.style.opacity = 0;

		document.body.appendChild(input);
	}, []);

	const isLocalhost = (process.env.NODE_ENV === "development");
	const isBillingPortal = (window?.location?.hostname === "billing-web.xilnex.com" || window?.location?.hostname === "billing.xilnex.com");
	const isBusinessPartnerPortal = (window?.location?.hostname === "partners-web.xilnex.com" || window?.location?.hostname === "partners.xilnex.com");

	return (
		<div className={"app"}>
			<Router history={createBrowserHistory()}>
				<Switch>
					{isBillingPortal || isLocalhost? (
						<Route path={billingPortalBaseUrl + "login"} component={Login} />
					):""}

					{isBillingPortal || isLocalhost? (
						<Route path={billingPortalBaseUrl + "dashboard"} component={Dashboard} />
					):""}

					{isBusinessPartnerPortal || isLocalhost? (
						<Route path={distributorPortalBaseUrl + "login"} component={Distributor_Login} />
					):""}
					
					{isBusinessPartnerPortal || isLocalhost? (
						<Route path={distributorPortalBaseUrl + "dashboard"} component={Distributor_Dashboard} />
					):""}

					<Redirect to={isBillingPortal? billingPortalBaseUrl + "login": distributorPortalBaseUrl + "login"} />
				</Switch>
			</Router>
		</div>
	);
}